<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="MGMT CO ADDRESS">
    <app-mgmt-company-address [company]="enrollment"></app-mgmt-company-address>
  </mat-tab>
  <mat-tab label="MGMT CO REPORTING">
    <app-enrollment-property-reporting [hide-responsibility]="true" [enrollment]="enrollment"></app-enrollment-property-reporting>
  </mat-tab>
  <mat-tab label="MGMT CO LICENSES">
    <app-mgmt-company-license [enrollment]="enrollment"></app-mgmt-company-license>
  </mat-tab>
  <mat-tab label="RENTAL OWNER">
    <app-property-detail-managed-owner [enrollment]="enrollment"></app-property-detail-managed-owner>
  </mat-tab>
  <mat-tab label="RENTAL PROPERTY">
    <app-mgmt-company-rental-property [property]="rental"></app-mgmt-company-rental-property>
  </mat-tab>
  <mat-tab label="RENTAL PROPERTY LICENSES">
    <app-enrollment-property-licenses [license]="license"></app-enrollment-property-licenses>
  </mat-tab>
</mat-tab-group>
